import Picture from "./components/Picture";
import FullsizePicture from "./components/FullsizePicture";

export { Picture, FullsizePicture };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-responsive-picture/es/index.js
// module id = 575
// module chunks = 11